import { AGENCY_JOBS_HISTORY_FETCH_BEGIN } from './action-types'
import type { AgencyJobsHistoryQuery } from './types'

// A plain action creator rather than createAction: entityReducer keys the result set from a
// top-level `options` field, which createAction's prepare callback cannot emit.
export const fetchAgencyJobsHistory = (options: AgencyJobsHistoryQuery) => ({
  type: AGENCY_JOBS_HISTORY_FETCH_BEGIN,
  options,
})

export type FetchAgencyJobsHistoryAction = ReturnType<typeof fetchAgencyJobsHistory>
